import {API, JSON_HEADER, JWT_HEADER} from 'config/srm.config';
import * as TYPES from './constants';
import {
  clearStudentFitSurveyResults,
  requestStudentFitSurveyResults,
  receiveStudentFitSurveyResults,
  handleStudentFitSurveyResultsError,
} from './actions';
const initialState = {
  request: null,
  data: null,
  error: null,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case TYPES.REQUEST_STUDENT_FIT_SURVEY_RESULTS:
      return {
        ...state,
        request: true,
      };
    case TYPES.RECEIVE_STUDENT_FIT_SURVEY_RESULTS:
      return {
        ...state,
        data: action.payload,
        request: false,
      };
    case TYPES.STUDENT_FIT_SURVEY_RESULTS_ERROR:
      return {
        ...state,
        error: true,
        request: false,
      };
    case TYPES.STUDENT_FIT_SURVEY_RESULTS_RESET:
      return {
        ...state,
        data: null,
      };
    default:
      return state;
  }
};

export const fetchFitAssessmentSurvey = student_uuid => (
  dispatch,
  getState
) => {
  const {
    auth: {
      access: {token},
    },
  } = getState();
  const config = {
    method: 'GET',
    mode: 'cors',
    headers: Object.assign({}, JWT_HEADER(token)),
    cache: 'default',
  };
  dispatch(requestStudentFitSurveyResults());
  try {
    return fetch(
      `${API.student.fit_assessment}?student_uuid=${student_uuid}`,
      config
    )
      .then(response => {
        if (response.ok) {
          return response.json();
        }
        throw new Error('Api Fails');
      })
      .then(json => {
        dispatch(receiveStudentFitSurveyResults(json));
      })
      .catch(err => {
        console.log(err);
        dispatch(handleStudentFitSurveyResultsError(err));
      });
  } catch (err) {
    console.log(err);
    dispatch(handleStudentFitSurveyResultsError(err));
  }
};

export const resetStudentSurveyResults = () => dispatch => {
  dispatch(clearStudentFitSurveyResults());
};
